import React, {useEffect, useState} from 'react';
import './scss/assets.scss';
import StatusView from "./status-view";
import Layout from "./layout";
import FullScreenLoader from "./full-screen";
import {Button, Modal} from 'react-bootstrap';
import EmptyView from "./empty-view";
import SandraJsAPI from "../services/sandraJsAPI";
import IAssetFilter from "../models/assets-filter";
import PaginationNova from "./pagination-nova";
import moment from "moment"
import {StatusMessageTypeEnum} from "../enums/StatusMessageTypeEnum";

function Assets(): React.ReactElement {
    const defaultFilter: IAssetFilter = {
        assetId: "",
        checkSubstring: false,
        moongaCardId: undefined,
        cannonAssetId: undefined
    }
    const emptyStatus = {message: '', type: StatusMessageTypeEnum.none};
    const defaultIds: (number | undefined)[] = [undefined];
    const [statusMessage, setStatusMessage] = useState(emptyStatus);
    const [isLoading, setIsLoading] = useState(false);
    const [assets, setAssets] = useState([])
    const [assetFilter, setAssetFilter] = useState(defaultFilter)
    const [currentPage, setCurrentPage] = useState(1);
    const [pageCount, setPageCount] = useState(10);
    const [itemCount, setItemCount] = useState(10);
    const [resetPaging, setResetPaging] = useState(false);
    const [pageIds, setPageIds] = useState(defaultIds)
    const [prevPageClick, setPrevPageClick] = useState(false)
    const [showModal, setShowModal] = useState(false)
    const [modalContent, setModalContent] = useState(<div></div>);

    useEffect(() => {
        fetchAssets()
    }, [currentPage, pageCount]);

    const fetchAssets = () => {
        setIsLoading(true);
        setStatusMessage(emptyStatus)
        SandraJsAPI.getAssetsByQuery(assetFilter, pageIds[currentPage - 1], pageCount + 1).then((data: any) => {
            const len = data?.data.length;
            let id = 0;
            setItemCount(len)
            if (!prevPageClick) {
                if (len > 1) {
                    id = data?.data[len - 2].tripletId
                } else if (len > 0) {
                    id = data?.data[len - 1].tripletId
                }
                if (currentPage >= pageIds.length) {
                    setPageIds([...pageIds, id])
                } else
                    setPageIds(pageIds.map((number, idx) => (idx === currentPage ? id : number)));
            }
            setAssets(data?.data?.slice(0, pageCount))
            setIsLoading(false);

        }).catch(e => {
            setStatusMessage({message: e.message, type: StatusMessageTypeEnum.error});
            console.error(e)
            setIsLoading(false);
        })
    }

    const fetchBindings = (asset: any) => {
        setIsLoading(true);
        setStatusMessage(emptyStatus)
        SandraJsAPI.getAssetBindingsByQuery(asset.id).then((data: any) => {
            setIsLoading(false);
            setModalContent(generateHtml(data?.data, asset));
            setShowModal(true);
        }).catch(e => {
            setStatusMessage({message: e.message, type: StatusMessageTypeEnum.error});
            console.error(e)
            setIsLoading(false);
        })
    }

    const filterBindings = (bindings: any[], set: any) => {
        return bindings.filter(b => {
                return (b.contractType == set.contractType && b.address == set.address && b.blockchain == set.blockchain && b.tokenId)
            }
        );
    }

    const generateHtml = (bindings: any[], asset: any) => {

        const set = new Set(bindings.map(obj => (obj.contractType) + "-" + obj.address + "-" + obj.blockchain + "-" + obj.contractId));

        const distinctSets = Array.from(set).map(str => {
            const attributes = str.split('-');
            return {
                contractType: attributes[0],
                address: attributes[1],
                blockchain: attributes[2],
                id:attributes[3]
            };
        });

        return (<div className="row">
            <div className="col-4">
                {asset.imgURL ? <> <img style={{
                    border: '2px solid #cecece', // 2px solid black border
                }} src={replaceIpfsWithEDSIpfs(asset.imgURL)} className="w-100 mt-2"/></> : <>Image data
                    not found</>}
            </div>
            <div className="col-8">
                <div>
                    <span className="p-2"><strong>Name:</strong></span><span
                    className="normal-text-italic">{asset.Name}</span>
                </div>
                <div>
                    <span className="p-2"><strong>Asset Id:</strong></span><span
                    className="normal-text-italic">{asset.assetId}</span>
                </div>
                <div>
                    <span className="p-2"><strong>Subject Id:</strong></span><span
                    className="normal-text-italic">{asset.id}</span>
                </div>

                <div className="note ps-2 pt-2">Urls stored in DB, image shown in list is replaced with our IPFS url
                </div>
                <div>
                    <span className="p-2"><strong>Image:</strong></span><a className="normal-text-italic"
                                                                           href={asset.imgURL}
                                                                           target="_blank">{asset.imgURL}</a>
                </div>
                <div>
                    <span className="p-2"><strong>Metadata:</strong></span><a className="normal-text-italic"
                                                                              href={asset.onChainMetaDataURL}
                                                                              target="_blank">{asset.onChainMetaDataURL}</a>
                </div>
                {distinctSets.map((set: any, index: any) => (
                    <>
                        <div className="p-2 mt-4" style={{backgroundColor: "#f0f8ff"}}>
                            <span className="normal-text-italic ps-1"><strong>{set.address}/{set.id}</strong></span>
                            <span className="pe-2  text-capitalize"
                                  style={{float: "right"}}><strong>{set.contractType}/{set.blockchain}</strong></span>
                        </div>
                        <div className="p-2">
                            {filterBindings(bindings, set)?.map((b: any, i: number) => (
                                <>
                                    <span className="pe-1">{b.tokenId || ""},</span>
                                </>
                            ))}
                        </div>
                    </>
                ))}
            </div>
        </div>);
    };
    const handlePageClick = (pageSize: number, pageNumber: number) => {
        if (pageNumber < currentPage) setPrevPageClick(true); else setPrevPageClick(false)
        setCurrentPage(pageNumber);
        setPageCount(pageSize);
    };

    const replaceIpfsWithEDSIpfs = (url: string) => {
        return url.replace("https://ipfs.io/ipfs/", "https://ipfsc.crystalsuite.com/");
    }
    const handleRowClick = (asset: any) => {
        fetchBindings(asset)
    };

    return (
        <Layout className="page assets loading-wrapper">
            <StatusView status={statusMessage}/>
            {isLoading ? <FullScreenLoader/> : <div/>}
            <div className="normal-text-italic search">
                <Modal show={showModal} onHide={() => setShowModal(false)} size="xl">
                    <Modal.Header closeButton>
                        <Modal.Title>Bindings</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <div>
                            <React.Fragment>{modalContent}</React.Fragment>
                        </div>
                    </Modal.Body>
                    <Modal.Footer>
                        <Button variant="secondary" onClick={() => setShowModal(false)}>
                            Close
                        </Button>
                    </Modal.Footer>
                </Modal>
                <div className="row justify-content-center">
                    <div className="col-3">
                        <input
                            type="text"
                            className="form-control "
                            placeholder="Asset Id"
                            onChange={(e) => setAssetFilter({...assetFilter, assetId: e.target.value})}
                        />
                    </div>
                    <div className="col-2 d-flex align-items-center">
                        <input
                            type="checkbox"
                            className="form-check-input mb-1"
                            checked={assetFilter.checkSubstring}
                            onChange={(e) => {
                                setAssetFilter({...assetFilter, checkSubstring: e.target.checked})
                            }}
                        />
                        <label className={"ps-2 pe-2"} htmlFor="checkbox">Check Substring</label>
                    </div>
                    <div className="col-2 d-flex align-items-center">
                        <input
                            type="checkbox"
                            className="form-check-input mb-1"
                            onChange={(e) => {
                                let val = e.target.checked ? null : undefined;
                                setAssetFilter({...assetFilter, moongaCardId: val})
                            }}
                        />
                        <label className={"ps-2 pe-2"} htmlFor="checkbox">Moonga Id Is Null</label>
                    </div>
                    <div className="col-2 d-flex align-items-center">
                        <input
                            type="checkbox"
                            className="form-check-input mb-1"
                            onChange={(e) => {
                                let val = e.target.checked ? null : undefined;
                                setAssetFilter({...assetFilter, cannonAssetId: val})
                            }}
                        />
                        <label className={"ps-2 pe-2"} htmlFor="checkbox">Canon Asset Id Is Null</label>
                    </div>
                    <div className="col-3">
                        <Button className="w-100" variant="primary"
                                onClick={(e) => {
                                    e.preventDefault();
                                    setResetPaging(!resetPaging)
                                    fetchAssets()
                                    return false;
                                }}
                        >
                            Search Asset
                        </Button>
                    </div>
                </div>
                <div className="pt-4">
                    <PaginationNova itemCount={itemCount} onPageClick={handlePageClick} reset={resetPaging}/>
                </div>
                <div className="row pt-4">
                    <div className="col-md-12">
                        <table className="assets-table">
                            <thead>
                            <tr>
                                <th>#
                                    ({((currentPage - 1) * pageCount) + 1} - {((currentPage - 1) * pageCount) + assets?.length})
                                </th>
                                <th>Image Url</th>
                                <th>On Chain Metadata Url</th>
                                <th>Triplet Id</th>
                                <th>Asset Subject Id</th>
                                <th>Asset Id</th>
                                <th>Moonga Card Id</th>
                                <th>Cannon Asset Id</th>
                                <th>Asset Name</th>
                                <th>Name</th>
                                <th>Bind To Abo</th>
                                <th>Mint Date</th>
                                <th>Binding</th>
                                <th>Creation Timestamp</th>
                            </tr>
                            </thead>
                            <tbody>
                            {(assets?.length > 0) ?
                                (
                                    assets.map((asset: any, index: any) => (
                                        <tr key={index + 1}

                                        >
                                            <td>{((currentPage - 1) * pageCount) + index + 1}</td>
                                            <td>
                                                {asset.imgURL ?
                                                    <img src={replaceIpfsWithEDSIpfs(asset.imgURL)} alt={"Card"}
                                                         height={100}
                                                         title={replaceIpfsWithEDSIpfs(asset.imgURL)}/> : "NA"}

                                            </td>
                                            <td>
                                                {asset.onChainMetaDataURL ?
                                                    <a href={replaceIpfsWithEDSIpfs(asset.onChainMetaDataURL)}
                                                       target="_blank">Metadata</a> : "NA"}

                                            </td>
                                            <td>{asset.tripletId}</td>
                                            <td>{asset.id}</td>
                                            <td>{asset.assetId}</td>
                                            <td>{asset.moongaCardId}</td>
                                            <td>{asset.cannonAssetId}</td>
                                            <td>{asset.assetName}</td>
                                            <td>{asset.Name}</td>
                                            <td>{asset.bindToAbo}</td>
                                            <td>{asset.mintDate}</td>
                                            <td>
                                                <span onClick={() => handleRowClick(asset)} style={{
                                                    textDecoration: 'underline',
                                                    cursor: 'pointer',
                                                    color: "#0d6efd"
                                                }}>View Binding</span>
                                            </td>
                                            <td>{moment(asset.creationTimestamp).format('YYYY-MM-DD HH:mm:ss')}</td>

                                        </tr>
                                    ))
                                )
                                : (
                                    <tr key={1}>
                                        <td colSpan={13}>
                                            <EmptyView title={"Records not found"}
                                                       desc={"Assets not listed in sandra"}/>
                                        </td>
                                    </tr>

                                )
                            }
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </Layout>
    );

}

export default Assets;
